import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { QuickOverview } from "@/components/dashboard/QuickOverview";
import { DashboardLayout } from '@/components/florist-dashboard/DashboardLayout';

export default function FloristAnalytics() {
  const navigate = useNavigate();
  const { user, isFlorist } = useAuth();

  React.useEffect(() => {
    if (!isFlorist) {
      navigate("/");
    }
  }, [isFlorist, navigate]);

  if (!user || !isFlorist) {
    return null;
  }

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div>
          <h1 className="text-3xl font-bold text-brand-primary">Analytics Dashboard</h1>
          <p className="text-brand-primary/70 mt-1">
            Track your store performance and sales
          </p>
        </div>

        <QuickOverview />
      </div>
    </DashboardLayout>
  );
} 